import classNames from 'classnames/bind';

import { Camera } from 'types/camera';

import { useStreams } from 'streams/hooks/useStreams';
import { useMqttStreamsState } from 'streams/hooks/useMqttStreamsState';

import { EmptyView } from 'components/EmptyView/EmptyView';
import { Loader } from 'components/Loader/Loader';

import { CameraStreamListElement } from './CameraStreamListElement';
import styles from './CameraDetailStreams.module.scss';

const c = classNames.bind(styles);

type CameraDetailStreamsProps = {
  camera: Camera;
};

export function CameraDetailStreams({ camera }: CameraDetailStreamsProps) {
  const { data: streams, isLoading } = useStreams({
    params: {
      sources: ['camera_stream'],
      camera_ids: [camera.id],
    },
  });

  useMqttStreamsState(streams ? streams.data.map(({ id }) => id) : []);

  if (isLoading) {
    return <Loader text="Loading camera streams..." size="small" />;
  }

  if (!streams || streams.total_elements === 0) {
    return <EmptyView>No camera streams configured.</EmptyView>;
  }

  return (
    <ul className={c('list')}>
      {streams &&
        streams.data.map((stream, idx) => (
          <CameraStreamListElement
            key={stream.id}
            streamID={stream.id}
            hideLoader={idx !== 0}
          />
        ))}
    </ul>
  );
}
